export function timeToColor() {
  const time = document.querySelector('.js-time-el');
  const color = document.querySelector('.js-color-el');

  if (time || color) {
    function timeToHSLColor(hours, minutes, seconds) {
      const hue = ((360 * (hours * 3600 + minutes * 60 + seconds) / 86400) % 360).toFixed(3);
      const saturation = 80;
      const lightness = 65;
      return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
    }

    const style = document.createElement('style')
    document.head.appendChild(style);
    
    // function invertHSLColor(hslColor) {
    //   const [hue, saturation, lightness] = hslColor.match(/\d+/g).map(Number);
    //   const invertedHue = (hue + 180) % 360;
    //   return `hsl(${invertedHue}, ${saturation}%, ${lightness}%)`;
    // }
  
    function updateTimeAndBackgroundColor() {
      const now = new Date();
      const hslColor = timeToHSLColor(now.getHours(), now.getMinutes(), now.getSeconds());

      style.textContent = `:root{--bgcolor: ${hslColor};}`;

      if (time) {
        time.textContent = now.toLocaleTimeString();
      }
      if (color) {
        color.textContent = `${hslColor}`;
      }
    }
  
    updateTimeAndBackgroundColor();
    setInterval(updateTimeAndBackgroundColor, 1000);
  }  
}
